export default import.meta.ROLLDOWN_FILE_URL_hD1i3GyoflofLbTk1JHt6A